<template>
    <div class="loader-wrapper" v-if="loading">
      <div class="loader"></div>
    </div>
    <section class="authentication-form" v-else>
      <div class="innerpage-decor">
        <div class="innerpage-circle1"><img :src='"../assets/images/Testimonial2.png"' alt=""></div>
        <div class="innerpage-circle2"><img :src='"../assets/images/Testimonial1.png"' alt=""></div>
      </div>
      <div class="text-center">
        <h2 class="title text-center"><span>Self Service</span></h2>
        <h3 class="title text-center mt-1 mb-0"><span>FUND WALLET</span></h3>
        <div class="card shadow mb-3">
          <img class="img-logo mx-auto" :src='"../assets/images/fmce-logo.png"' alt="">
          <h3 class="text-center mb-0">Welcome {{ currentPatient.full_name }}</h3>
          <p class="text-center">Please enter an amount you would like to fund your wallet with</p>
          <form class="theme-form" @submit.prevent="submit" novalidate="novalidate" autocomplete="false">
            <div class="form-group">
              <label>Transaction Fee: ₦{{ fee.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }}</label>
              <input type="number" min="100" class="form-control text-uppercase text-center" placeholder="Enter Amount" v-model.trim="$v.amount.$model">
              <label class="mt-2"><b class="text-info">Total: ₦{{ total.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') }}</b></label>
              <template v-if="$v.amount.$error">
                <span
                  class="form-text text-danger text-center"
                  v-if="!$v.amount.required"
                >
                  Please enter a valid amount to fund wallet with.
                </span>
                <span
                  class="form-text text-danger text-center"
                  v-if="!$v.amount.numeric"
                >
                  Please enter a valid amount to fund wallet with.
                </span>
              </template>
            </div>
            <div class="form-button text-center">
              <button type="submit" class="btn btn-custom btn-lg btn-block theme-color">CONTINUE</button>
            </div>
            <div class="form-button text-center mt-2">
              <button @click="cancel()" type="button" class="btn btn-custom btn-lg btn-block btn-danger">CANCEL</button>
            </div>
          </form>
        </div>
        <small><b>Nuclear Associates &amp; Consulting Services</b><br>No. 3, Alhaja Kofoworola Crescent off Obafemi Awolowo Way, Ikeja-Lagos</small><br>
      </div>
    </section>
</template>
<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { mapGetters } from 'vuex'
import { required, numeric } from 'vuelidate/lib/validators'
import { INITIATE_FUNDING } from '@/store/bill.module'
import { PURGE_PATIENT } from '@/store/welcome.module'

export default {
  name: 'FundWallet',
  data () {
    return {
      amount: '',
      loading: false
    }
  },
  validations: {
    amount: { required, numeric }
  },
  computed: {
    ...mapGetters(['currentPatient', 'currentBill']),
    fee () {
      if (!isNaN(this.amount)) {
        let value = (this.amount * 0.014)
        let actualFee = value > 2000 ? 2000 : value
        return actualFee
      } else {
        return 0
      }
    },
    total () {
      if (this.fee > 0) {
        return parseFloat(this.fee) + parseFloat(this.amount)
      } else {
        return 0
      }
    }
  },
  mounted () {},
  methods: {
    async submit () {
      try {
        this.$v.$touch()
        if (!this.$v.$invalid) {
          this.loading = true

          let params = {
            payer_name: this.currentPatient.full_name,
            payer_no: this.currentPatient.id,
            amount: this.amount,
            revenue_unit_id: 4348 // TODO : Parameterize
          }

          this.$store.dispatch(INITIATE_FUNDING, params)
            .then(response => {
              if (this.currentBill.payment.status === 'success') {
                window.location.href = this.currentBill.payment.data.link
              } else {
                this.loading = false
                this.$swal({
                  title: 'Bear With Us',
                  text: 'We have a little dificulty generating a payment link please try again',
                  icon: 'warning',
                  heightAuto: false
                })
              }
            })
            .catch(() => {
              this.loading = false
              this.$swal({
                title: 'Bear With Us',
                text: 'We have a little technical dificulty please try again',
                icon: 'warning',
                heightAuto: false
              })
            })
        }
      } catch (error) {
        this.loading = false
        this.$swal({
          title: 'Warning',
          text: 'An unexpected error occured!',
          icon: 'warning',
          heightAuto: false
        })
      }
    },

    makeGlobalPayPayment (params) {
      let method = 'post'
      var form = document.createElement('form')
      form.submit_function = form.submit

      form.setAttribute('method', method)
      form.setAttribute('action', 'https://demo.globalpay.com.ng/GlobalPayAPI/Paymentgatewaycapture.aspx')

      for (var key in params) {
        var hiddenField = document.createElement('input')
        hiddenField.setAttribute('type', 'hidden')
        hiddenField.setAttribute('name', key)
        hiddenField.setAttribute('value', params[key])

        form.appendChild(hiddenField)
      }

      document.body.appendChild(form)
      form.submit_function()
    },

    cancel () {
      this.loading = true
      this.$store.dispatch(PURGE_PATIENT)
        .then(response => {
          this.loading = false
          this.$router.push({ name: 'Welcome' })
        })
        .catch(error => {
          this.loading = false
          this.$swal({
            title: 'An Error Occured',
            text: error.message,
            icon: 'error',
            heightAuto: false
          })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/fund-wallet.vue